import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './style.css';

class Loading extends Component {
    static propTypes = {
        playermsg: PropTypes.object.isRequired,
        narrowWindowMode: PropTypes.bool.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            showImg: true,
            isRender: true,
        };
    }
    show = () => {
        this.setState({
            showImg: true,
        });
    };
    hide = () => {
        this.setState({
            showImg: false,
        });
    };
    destroy = () => {
        this.setState({
            isRender: false,
        });
    };
    render() {
        const {
            playermsg: { width, height },
            narrowWindowMode,
        } = this.props;

        return this.state.isRender ? (
            <div
                style={{
                    display: this.state.showImg ? 'block' : 'none',
                    width,
                    height,
                    position: 'relative',
                }}
                className={`${styles.loading} ${narrowWindowMode ? styles.narrowWindow : ''}`}>
                <div className={styles.loadingbanner} />
            </div>
        ) : null;
    }
}

export default Loading;
